import { useQuery } from '@contexts/index'

import { SelectInput } from '../baseInputs'

type Props = {
  dealers?: []
  helper?: string
  optional?: boolean
  label?: string
  showBadge?: boolean
  onRemoveGroup?: () => void
}

const ClosestDealers = ({
  helper,
  dealers,
  label,
  optional,
  showBadge = false,
  onRemoveGroup,
  ...rest
}: Props) => {
  const name = 'dealer'
  const query = useQuery()

  return (
    <SelectInput
      name={name}
      label={label}
      options={dealers}
      helper={helper}
      optional={optional}
      showBadge={!!(query?.group && showBadge)}
      badgeGroupName={(query?.groupName as string) || 'Group'}
      onRemoveBadge={onRemoveGroup}
      {...rest}
    />
  )
}

export default ClosestDealers
